var render = function render() {
  var _vm$stockImage$attrib, _vm$stockImage$attrib2
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "stock-images-selectable-image",
      attrs: {
        tabindex: "0",
      },
    },
    [
      _c("Thumbnail", {
        staticClass: "stock-images-image-card__thumbnail",
        attrs: {
          url: _vm.thumbnailUrl,
          contain: "",
          width: "8rem",
        },
      }),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          _vm._s(
            (_vm$stockImage$attrib =
              (_vm$stockImage$attrib2 = _vm.stockImage.attributes) === null ||
              _vm$stockImage$attrib2 === void 0
                ? void 0
                : _vm$stockImage$attrib2.title) !== null &&
              _vm$stockImage$attrib !== void 0
              ? _vm$stockImage$attrib
              : ""
          )
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }